import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import updateLocale from 'dayjs/plugin/updateLocale';
import deLocale from 'dayjs/locale/de';
import weekday from 'dayjs/plugin/weekday';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import objectSupport from 'dayjs/plugin/objectSupport';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isToday from 'dayjs/plugin/isToday';

dayjs.extend(localeData);
dayjs.extend(updateLocale);
dayjs.extend(weekday);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(objectSupport);
dayjs.extend(quarterOfYear);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isToday);

import 'dayjs/locale/bg';
import 'dayjs/locale/cs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fi';
import 'dayjs/locale/fr';
import 'dayjs/locale/ko';
import 'dayjs/locale/hr';
import 'dayjs/locale/hu';
import 'dayjs/locale/it';
import 'dayjs/locale/nl';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/ro';
import 'dayjs/locale/sk';
import 'dayjs/locale/tr';
import 'dayjs/locale/th';
import 'dayjs/locale/zh';
import 'dayjs/locale/ja';

// Base Spec common to all locales
const baseLocaleOptions = {
  weekStart: 1
};

const localeList = dayjs.Ls;

// customize locales
dayjs.updateLocale('bg', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.bg.relativeTime,
    s: 'точно сега'
  }
});

dayjs.updateLocale('cs', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.cs.relativeTime,
    s: 'právě teď'
  }
});

dayjs.updateLocale('de', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.de.relativeTime,
    s: 'gerade eben'
  }
});

dayjs.updateLocale('en', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.en.relativeTime,
    s: 'just now'
  }
});

dayjs.updateLocale('es', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.es.relativeTime,
    s: 'ahora mismo'
  }
});

dayjs.updateLocale('fi', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.fr.relativeTime,
    s: 'juuri nyt'
  }
});

dayjs.updateLocale('fr', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.fr.relativeTime,
    s: 'maintenant'
  }
});

dayjs.updateLocale('ko', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.ko.relativeTime,
    s: '지금'
  }
});

dayjs.updateLocale('hr', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.hr.relativeTime,
    s: 'upravo sad'
  }
});

dayjs.updateLocale('hu', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.hu.relativeTime,
    s: 'éppen most'
  }
});

dayjs.updateLocale('it', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.it.relativeTime,
    s: 'adesso'
  }
});

dayjs.updateLocale('nl', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.nl.relativeTime,
    s: 'zojuist'
  }
});

dayjs.updateLocale('pl', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.pl.relativeTime,
    s: 'właśnie teraz'
  }
});

dayjs.updateLocale('pt', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.pt.relativeTime,
    s: 'agora mesmo'
  }
});

dayjs.updateLocale('ro', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.ro.relativeTime,
    s: 'chiar acum'
  }
});

dayjs.updateLocale('sk', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.sk.relativeTime,
    s: 'práve teraz'
  }
});

dayjs.updateLocale('tr', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.sk.relativeTime,
    s: 'şu anda'
  }
});

dayjs.updateLocale('th', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.th.relativeTime,
    s: 'เมื่อกี้'
  }
});

dayjs.updateLocale('zh', {
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.zh.relativeTime,
    s: '刚才'
  }
});

const akLocale = {
  ...deLocale,
  ...baseLocaleOptions,
  relativeTime: {
    ...localeList.de.relativeTime,
    s: 'gerade eben'
  },
  name: 'ak'
};

dayjs.locale(akLocale, null, true);

// Need to import and run default export to execute file
export default dayjs;
